import styled from 'styled-components';

const clsPrefix = 'ui-password-strength';
const trackCls = `${clsPrefix}-track`;
const labelCls = `${clsPrefix}-label`;

export const passStrengthCls = {
  wrapper: clsPrefix,
  track: `${trackCls}-wrapper`,
  trackItem: `${trackCls}-item`,
  labelWrapper: labelCls,
  strength: `${labelCls}-strength`,
  label: `${labelCls}-label`,
} as const;

export const PasswordStrengthSC = styled.div`
  width: 100%;

  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;

  .${passStrengthCls.track} {
    flex: 1;
    width: 100%;
    height: 4px;

    overflow: hidden;
    transition: all 0.2s;

    border-radius: 4px;
    background: ${({ theme }) => theme.color.surface.secondary};
    margin: 8px 0;

    .${passStrengthCls.trackItem} {
      transition: all 0.2s;
      height: 4px;
    }
  }

  .${passStrengthCls.labelWrapper} {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .${passStrengthCls.label} {
      color: ${({ theme }) => theme.color.tint.tertiary};
      white-space: nowrap;
    }

    .${passStrengthCls.strength} {
      flex: 1;
      text-align: right;
    }
  }
`;
